import { Component } from '@angular/core';
// import { BsModalRef } from 'ngx-bootstrap/modal';
// import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  

static closeWindow(reference : MatDialog){
  setTimeout(()=>{reference.closeAll();},1000);
}

}
